import type { CommunicationInboxItem } from "@/types/communications";
import type {
  GoHighLevelCalendar,
  GoHighLevelContact,
  GoHighLevelConversation,
  GoHighLevelEntity,
  GoHighLevelMessage,
  GoHighLevelOpportunity,
} from "@/types/gohighlevel";

export function goHighLevelConversationToInboxItem(c: GoHighLevelConversation): CommunicationInboxItem {
  return {
    id: c.id,
    subject: c.subject,
    from: c.from,
    date: c.date,
    preview: c.preview,
    type: c.type || c.channel || "conversation",
    read: c.read,
  };
}

export function goHighLevelMessageToInboxItem(m: GoHighLevelMessage): CommunicationInboxItem {
  return {
    id: m.id,
    subject: m.subject,
    from: m.from,
    date: m.date,
    preview: m.preview,
    type: m.type || "message",
    read: m.read ?? true,
  };
}

export function goHighLevelContactToInboxItem(c: GoHighLevelContact): CommunicationInboxItem {
  return {
    id: c.id,
    subject: c.subject,
    from: c.from,
    date: c.date,
    preview: c.preview,
    type: "contact",
    read: true,
  };
}

export function goHighLevelOpportunityToInboxItem(o: GoHighLevelOpportunity): CommunicationInboxItem {
  return {
    id: o.id,
    subject: o.subject,
    from: o.from,
    date: o.date,
    preview: o.preview,
    type: "opportunity",
    read: true,
  };
}

export function goHighLevelCalendarToInboxItem(c: GoHighLevelCalendar): CommunicationInboxItem {
  return {
    id: c.id,
    subject: c.subject,
    from: c.from,
    date: c.date,
    preview: c.preview,
    type: "calendar",
    read: true,
  };
}

export function goHighLevelEntityToInboxItem(entity: GoHighLevelEntity): CommunicationInboxItem {
  switch (entity.type) {
    case "contact":
      return goHighLevelContactToInboxItem(entity as GoHighLevelContact);
    case "opportunity":
      return goHighLevelOpportunityToInboxItem(entity as GoHighLevelOpportunity);
    case "calendar":
      return goHighLevelCalendarToInboxItem(entity as GoHighLevelCalendar);
    default:
      return goHighLevelConversationToInboxItem(entity as GoHighLevelConversation);
  }
}
